import { AlertTriangle, Loader2 } from 'lucide-react';
import type { AdminUserRecord } from '@/api/adminAdmins';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface AdminDeleteDialogProps {
  admin: AdminUserRecord | null;
  isDeleting: boolean;
  error: string | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function AdminDeleteDialog({ admin, isDeleting, error, onOpenChange, onConfirm }: AdminDeleteDialogProps) {
  return (
    <Dialog open={admin !== null} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-left">
          <div className="mb-2 flex h-11 w-11 items-center justify-center rounded-2xl bg-rose-50 text-rose-700 ring-1 ring-rose-100">
            <AlertTriangle className="h-5 w-5" aria-hidden="true" />
          </div>
          <DialogTitle>Διαγραφή λογαριασμού;</DialogTitle>
          <DialogDescription className="leading-6">
            Ο λογαριασμός <strong className="font-semibold text-slate-800">{admin?.username}</strong> και τα στοιχεία σύνδεσής του θα διαγραφούν οριστικά. Η ενέργεια δεν αναιρείται.
          </DialogDescription>
        </DialogHeader>

        {error && (
          <div role="alert" className="rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm font-medium leading-6 text-rose-800">
            {error}
          </div>
        )}

        <DialogFooter className="gap-2 sm:mt-2">
          <Button type="button" variant="outline" className="h-11" onClick={() => onOpenChange(false)} disabled={isDeleting}>
            Διατήρηση λογαριασμού
          </Button>
          <Button type="button" variant="destructive" className="h-11" onClick={onConfirm} disabled={isDeleting || !admin?.canDelete}>
            {isDeleting && <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />}
            {isDeleting ? 'Διαγραφή…' : 'Οριστική διαγραφή'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
